import React, { useEffect, useState } from 'react'
import { DefaultButton, IDropdownOption, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton } from '@fluentui/react';

import { IChoiceField, IField, IRuoloAoo, ITextField, IUser, IUserField } from '../../../shared/interfaces';
import DynamicForm from '../../DynamicForm/DynamicForm';
import { useBoolean } from '@fluentui/react-hooks';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import usersService from '../../../services/users.service';
import { RootState } from '../../../store';
import { connect, ConnectedProps } from 'react-redux';
import { AddEditUserAoo_Mode, RoleContext } from '../../../shared/enums';
import { toastRef } from '../../Layout/Layout';
import Utilities from '../../../shared/Utilities/utilities';
import { RouteComponentProps, withRouter } from 'react-router-dom';



const mapState = (state: RootState) => ({
    allRoles: state.sessionReducer.allRoles,
    userActiveAoo: state.sessionReducer.userActiveAoo,
    currentUser: state.sessionReducer.currentUser
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface AddUserAooProps {
    loading?: boolean
    extraCssClass?: string
    selectedUser?: Partial<IUser>
    panelHeaderText: string
    panelIsOpen: boolean
    onSubmit: (userItem: IUser, addEditUserMode: AddEditUserAoo_Mode) => void
    onDismiss: () => void
    panelIsEdit: boolean

    peopleList: IUser[]
}

type Props = AddUserAooProps & RouteComponentProps & PropsFromRedux

const AddUserAoo: React.FunctionComponent<Props> = (props) => {
    let loading = props.loading !== undefined ? props.loading : false;

    const [panelIsOpen, setPanelIsOpen] = useState<boolean>(props.panelIsOpen);
    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');
    const [fields, setFields] = useState<IField[]>([]);
    const [rolesOptions, setRolesOptions] = useState<IDropdownOption[]>([]);
    const [defaultAooOptions, setDefaultAooOptions] = useState<IDropdownOption[]>([]);


    useEffect(() => {

        resetFields();
        dismissMessageBar();
        setPanelIsOpen(props.panelIsOpen);

    }, [props.panelIsOpen]);

    useEffect(() => {
        resetFields();
    }, [props.selectedUser]);

    useEffect(() => {
        let aooOptions = props.userActiveAoo ? props.userActiveAoo.map(el => { return { text: el.name, key: el.id } }) : [];
        setDefaultAooOptions(aooOptions);
    }, [props.userActiveAoo]);

    useEffect(() => {
        let _rolesOptions = props.allRoles ? props.allRoles.reduce((a: any[], o) => (o.context === RoleContext.Aoo && a.push({ text: o.nome, key: o.id }), a), []) : [];
        setRolesOptions(_rolesOptions);
    }, [props.allRoles]);

    useEffect(() => {
        if (rolesOptions.length > 0) {
            resetFields();
        }
        if (defaultAooOptions.length > 0) {
            resetFields();
        }
    }, [rolesOptions, defaultAooOptions]);

    const resetFields = () => {
        let personaReadOnly = false;
        let personaValue: any[] = [];
        let ruoloValue;
        let defaultAooValue;
        let userEmailValue;
        let notificaGiornalieraValue;
        let isSuperAdmin;
        let user = props.selectedUser;
        let aooId = Number(props.match.params["aooId"]);

        //Quando seleziono un utente, vuol dire che sto in modifica e tiro su i dati
        if (props.selectedUser) {
            let personaSelezionata = props.selectedUser;
            personaReadOnly = true;

            // Per l'user
            personaValue.push({

                key: personaSelezionata.userId,
                imageUrl: personaSelezionata.imageUrl,
                imageInitials: personaSelezionata.initials,
                presence: personaSelezionata.presence,
                text: personaSelezionata.displayName,
                secondaryText: personaSelezionata.userId,
                showSecondaryText: true,
                hidePersonaDetails: false,
                user: personaSelezionata

            });


            // Per il ruolo (Admin o Supervisore)
            let admin = usersService.userIsAdmin(personaSelezionata!, aooId);
            if (admin) {
                let adminRole = props.allRoles?.find(el => el.nome === "Admin");
                ruoloValue = adminRole!.id;
            }
            else {
                let supervisore = usersService.userIsSupervisore(personaSelezionata!, aooId);
                if (supervisore) {
                    let supervisorRole = props.allRoles?.find(el => el.nome === "Supervisore");

                    ruoloValue = supervisorRole!.id;
                }
            }
            // Per Defaul Aoo
            defaultAooValue = personaSelezionata.defaultAoo?.id;

            // Per l'email
            userEmailValue = personaSelezionata.emailNotifica;

            // Per notifica giornaliera
            //notificaGiornalieraValue = personaSelezionata.notificaGiornaliera;

            isSuperAdmin = personaSelezionata.isSuperAdmin;

        }

        //ricreo i fields a partire da initialFields e aggiungo le options per il field ruolo e per il default Aoo
        let newFields = [
            {
                displayName: "Utente",
                internalName: "utente",
                sharepointType: "User",
                controlType: "autocompleteUser",
                required: true,
                readonly: personaReadOnly,
                disabled: false,
                system: false,
                internalValue: personaValue,
                valid: false,
                touched: false,
                multi: false

            } as IUserField,
            {
                displayName: "Ruolo nell'AOO corrente",
                internalName: "ruolo",
                sharepointType: "Choice",
                controlType: "dropdown",
                required: true,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: ruoloValue,
                valid: false,
                touched: false,
                multi: false,
                options: rolesOptions

            } as IChoiceField,
            {
                displayName: "Default Aoo",
                internalName: "defaultAoo",
                sharepointType: "Choice",
                controlType: "dropdown",
                required: true,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: defaultAooValue,
                valid: false,
                touched: false,
                multi: false,
                options: defaultAooOptions

            } as IChoiceField,
            {
                displayName: "Email Notifica",
                internalName: "email",
                sharepointType: "Text",
                controlType: "textbox",
                required: true,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: userEmailValue ? userEmailValue : user?.userId,
                valid: false,
                touched: false,
                pattern: Utilities.GetRegexEmailSingola(),
            } as ITextField,

            //    {
            //        displayName: "Notifica Giornaliera",
            //        internalName: "notificaGiornaliera",
            //        sharepointType: "Yes/No",
            //        controlType: "boolean",
            //        required: false,
            //        readonly: false,
            //        disabled: false,
            //        system: false,
            //        internalValue: notificaGiornalieraValue,
            //        valid: false,
            //        touched: false
            //    } as IField
        ];
        if (props.currentUser?.isSuperAdmin) {
            newFields.push(
                {
                    displayName: "SuperAdmin",
                    internalName: "isSuperAdmin",
                    sharepointType: "Yes/No",
                    controlType: "boolean",
                    required: false,
                    readonly: false,
                    disabled: false,
                    system: false,
                    internalValue: isSuperAdmin,
                    valid: false,
                    touched: false
                } as IField);
        }

        setFields(newFields);
    }

    // Click su salva del panel laterale
    const addEditUsersAooManagerPanelSubmit = () => {

        if (checkUserAooManagerFormValidity()) {
            let user: IUser = fields.find(el => el.internalName === 'utente')?.internalValue[0].user;
            let ruoloId = fields.find(el => el.internalName === 'ruolo')?.internalValue;
            let defaultAooId = fields.find(el => el.internalName === 'defaultAoo')?.internalValue;
            let emailNotifica = fields.find(el => el.internalName === 'email')?.internalValue;
            let notificaValue = fields.find(el => el.internalName === 'notificaGiornaliera')?.internalValue;
            let notificaGiornaliera = notificaValue ? true : false;
            let isSuperAdmin = fields.find(el => el.internalName === 'isSuperAdmin')?.internalValue;

            let aooId = props.match.params["aooId"];
            let ruoliAooContext: IRuoloAoo[] = [{ ruoloId, utenteId: user.userId, aooId }];

            let newUser: IUser = { ...user, defaultAooId, emailNotifica, notificaGiornaliera, ruoliAooContext, isSuperAdmin };

            props.onSubmit(newUser, AddEditUserAoo_Mode.AddUser);

            resetFormFields();
        }
    }

    const resetFormFields = () => {

        let newFields = fields.map(el => {
            return { ...el, internalValue: null, touched: false, valid: true };
        });
        setFields(newFields);
    }

    const checkUserAooManagerFormValidity = (): boolean => {

        let isValid = true;

        const updatedFields = fields.map((item, index) => {
            let fieldValidity = AppUtilities.checkFieldValidity(item);
            if (!fieldValidity)
                isValid = false;

            return {
                ...item,
                touched: true,
                valid: fieldValidity
            }
        });
        setFields(updatedFields);
        if (isValid) {
            dismissMessageBar();
        }
        else {
            setMessageBarText('Compilare correttamente i campi');
            setMessageBarType(MessageBarType.error);
            showMessageBar();
        }

        return isValid;
    }


    const inputChangedHandler = (newField: IField) => {

        const updatedFields = [...fields];
        let itemIndex = updatedFields.findIndex(el => el.internalName === newField.internalName);

        if (newField.internalName === 'utente' && newField.internalValue && newField.internalValue.length > 0 && props.peopleList.findIndex(el => el.userId === newField.internalValue[0].user.userId) >= 0) {
            toastRef.current?.show({ severity: 'warn', summary: 'Attenzione', detail: `L'utente selezionato è già stato aggiunto`, life: 5000 });
        }
        else if (newField.internalName === 'utente') {
            dismissMessageBar();
        }

        updatedFields[itemIndex] = { ...newField };

        if (newField.internalName === 'utente' && newField.internalValue) {
            // Quando un utente è selezionato, viene popolato automaticamente il campo email con l'email di dafult
            let userId = newField.internalValue[0]?.key;
            let emailFieldIndex = updatedFields.findIndex(el => el.internalName === 'email');
            let emailField = { ...updatedFields[emailFieldIndex] };
            emailField.internalValue = userId;

            updatedFields[emailFieldIndex] = { ...emailField };
        }

        setFields(updatedFields);
    }

    const onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Salva"
                    onClick={addEditUsersAooManagerPanelSubmit}
                />
                <DefaultButton
                    onClick={props.onDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <Panel
                key='addEditUsersAooManagerPanel'
                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'600px'}
                headerText={props.panelHeaderText}
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={props.onDismiss}
                onRenderFooterContent={onRenderLateralPanelFooterContent}
                // Stretch panel content to fill the available height so the footer is positioned
                // at the bottom of the page
                isFooterAtBottom={false}
            >
                {messageBarIsVisible &&
                    <MessageBar
                        messageBarType={messageBarType}
                        isMultiline={false}
                        onDismiss={dismissMessageBar}
                        dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
                }

                <CircleLoader loaderClass='loader-large' loading={loading} />




                <div className={"flex flex-column position-relative overflow-hidden"}>

                    <div className={`position-relative my-scroll-div`}>

                        <DynamicForm
                            fields={fields}
                            onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
                        />
                    </div>
                </div>
            </Panel>

        </React.Fragment>

    );
}

export default connector(withRouter(AddUserAoo));
